export class ContactGroup {
    public id;
    public groups_id;
    public contacts_id;
    public owner;
}

